import {getBaseUrl, getQueryString} from "./common";
import Form from "./form";

export class LoginForm {
    private form: HTMLFormElement;

    constructor(form: HTMLFormElement) {
        this.form = form;
    }

    processForm(event: Event): void {
        const queryParams = getQueryString();
        const url = queryParams == ''
            ? `${getBaseUrl()}login`
            : `${getBaseUrl()}login?${queryParams}`;
        
        const form = new Form(url, this.form, null, (html: string) => {
            document.querySelector(
                '[data-component="LoginForm"]'
            ).innerHTML = html;
        });

        form.process(event);
    }
}
